export default "__VITE_ASSET__Co0MIAs9__"